import React from "react";
import { Container } from "./styles/section";

export default function Section({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}